import api from '../../api';
import environment from '../../environment';
import { ContextEnum } from '../../../enuns/context.enum';

const streetView = () => require('../../core/map/streetview').default;

class StreetViewAction {
    constructor ({ layer, currentMap }) {
        return {
            check: () => false,
            layer,
            map: currentMap,
            icon: 'icon_bubble_streetview',
            title: 'Street View',
            click () {
                api.general.log.action(ContextEnum.PinStore, 'Street View');
                streetView().show(layer.getLatLng());
            }
        };
    }
}

export default StreetViewAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/StreetViewAction.js